import { Flex, Heading, Button, Input, Box, FormControl, FormLabel, Spinner } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb'
import CustomInput from '../../../../components/common/Input/input'
import * as api from '../../../../api/secretarias';
import Swal from 'sweetalert2'
import './adicionar-secretaria.scss'

function AdicionarSecretaria() {
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState({
    codSecretaria: {
      value: '',
      error: false
    },
    dscSecretaria: {
      value: '',
      error: false
    },
  })

  const isFormValid = () => {
    const { codSecretaria, dscSecretaria } = formValues;

    return (
      codSecretaria.value && dscSecretaria.value &&
      codSecretaria.value.length <= 10 && dscSecretaria.value.length >= 3
    );
  };

  const handleFieldChange = (field: any, value: any) => {
    setFormValues({
      ...formValues,
      [field]: {
        error: false,
        value
      }
    });
  };

  const handleSubmit = async () => {
    try {
      const {
        codSecretaria,
        dscSecretaria,
      } = formValues;
  
      const params = {
        codSecretaria: codSecretaria.value,
        dscSecretaria: dscSecretaria.value || null,
        numAtivo: 1
      };
  
      setIsLoading(true);
      await api.inserirSecretaria(params);
      Swal.fire({
        icon: "success",
        title: "Sucesso!",
        html: "Secretaria adicionada com sucesso.",
        confirmButtonColor: "#1789FC",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/cms/configuracao/gerenciar-secretarias");
      });
    } catch (error) {
      setErrorMessage("Houve um problema ao adicionar a secretaria. Tente novamente.");
      Swal.fire({
        icon: "error",
        title: "Ocorreu um erro",
        html: "Não conseguimos adicionar a secretaria no momento. Por favor, tente novamente mais tarde.",
        confirmButtonColor: "#1789FC",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/cms/configuracao/gerenciar-secretarias");
      });
      setIsLoading(false);
    }
  };  

  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      <SettingsBreadcrumb />
      <Heading
        mt="30px"
        mb="20px"
        fontWeight="600"
        fontSize="21px"
        color="#6F6F6F"
        w="100%"
      >
        Adicionar Secretaria
      </Heading>
      {isLoading ? (
        <Flex
          justify="center"
          align="center"
          direction="column"
          w="70%"
          h="90%"
          position='fixed'
        >
          <Spinner size="xl" color="blue.500" />
        </Flex>
      ) : (
        <><div className="row mb-3">
          <div className="col-md-6 mb-4">
            <FormControl isRequired>
              <FormLabel mb="8px">Código</FormLabel>
              <Input
                type="number"
                placeholder='Digite um código'
                backgroundColor={'#fff'}
                variant="outline"
                borderColor="gray.300"
                _hover={{
                  borderColor: 'blue.500',
                }}
                _focus={{
                  borderColor: 'blue.500',
                  boxShadow: '0 0 0 1px blue.500',
                }}
                value={formValues.codSecretaria.value}
                onChange={(e) => handleFieldChange('codSecretaria', e.target.value.trim())}
                maxLength={10} 
                minLength={1}
                />
            </FormControl>
          </div>
          <div className="col-md-6 mb-4">
            <FormControl isRequired>
              <FormLabel mb="8px">Descrição</FormLabel>
              <CustomInput
                placeholder='Digite uma descrição'
                value={formValues.dscSecretaria.value}
                onChange={(e) => handleFieldChange('dscSecretaria', e.target.value)}
                maxLength={150}
                minLength={3} />
            </FormControl>
          </div>
        </div>
          <Flex justifyContent="end">
            <Button type="submit" m="6px" onClick={() => navigate(-1)}>
              Desistir
            </Button>
            <Button
              type="submit"
              m="6px"
              color="#FFF"
              bgColor="#1665D8"
              _hover={{ opacity: 0.8 }}
              onClick={() => {
                handleSubmit()
              }}
              isDisabled={!isFormValid()}
            >
              Adicionar Secretaria
            </Button>
          </Flex></>)}
    </Flex>
  )
}

export default AdicionarSecretaria;
